export const IMAGE_VERTICAL = 'vertical';
export const IMAGE_HORIZONTAL = 'horizontal';
